/// <amd-module name="SuiteCommerce.PhotoGallery.CCT.Settings" />
define("SuiteCommerce.PhotoGallery.CCT.Settings", ["require", "exports", "Utilities.ResizeImage", "SuiteCommerce.PhotoGallery.Common.Utils", "underscore"], function (require, exports, resizeImage, Utils_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MAX_PHOTOS = 8;
    var COLUMNS_PER_ROW = 4;
    var CAROUSEL_GALLERY_STYLE = 2;
    var GALLERY_HEIGHT = {
        1: 'gallery-height-sm',
        2: 'gallery-height-md',
        3: 'gallery-height-lg',
    };
    var IMAGE_ALIGNMENT = {
        1: 'image-alignment-left-top',
        2: 'image-alignment-left-middle',
        3: 'image-alignment-left-bottom',
        4: 'image-alignment-center-top',
        5: 'image-alignment-center-middle',
        6: 'image-alignment-center-bottom',
        7: 'image-alignment-right-top',
        8: 'image-alignment-right-middle',
        9: 'image-alignment-right-bottom',
    };
    var IMAGE_OVERLAY = {
        1: '',
        2: 'content-dark',
        3: 'content-light',
    };
    var TEXT_COLOR = {
        1: 'text-dark',
        2: 'text-light',
    };
    var TEXT_ALIGNMENT = {
        1: 'text-alignment-left-top',
        2: 'text-alignment-left-middle',
        3: 'text-alignment-left-bottom',
        4: 'text-alignment-center-top',
        5: 'text-alignment-center-middle',
        6: 'text-alignment-center-bottom',
        7: 'text-alignment-right-top',
        8: 'text-alignment-right-middle',
        9: 'text-alignment-right-bottom',
    };
    var IMAGES_HOVER_ANIMATION = {
        1: '',
        2: 'image-scale-up',
        3: 'image-scale-down',
        4: 'image-drop-shadow-center',
        5: 'image-drop-shadow-top',
        6: 'image-drop-shadow-bottom',
    };
    var CAROUSEL_ANIMATION_TIME = {
        1: '0',
        2: '5000',
        3: '7000',
        4: '10000',
    };
    var PhotoGalleryCCTSettings = /** @class */ (function () {
        function PhotoGalleryCCTSettings(cctSettings, container) {
            this.cctSettings = cctSettings;
            this.container = container;
        }
        PhotoGalleryCCTSettings.prototype.getImagesAttributes = function () {
            var imagesAttributes = [];
            for (var i = 1; i <= MAX_PHOTOS; i++) {
                var imageAttributes = this.getImageAttributes(i);
                if (imageAttributes.imageURL) {
                    imagesAttributes.push(imageAttributes);
                }
            }
            return imagesAttributes;
        };
        PhotoGalleryCCTSettings.prototype.getImageAttributes = function (itemNumber) {
            var imageURL = Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_img" + itemNumber + "_url"]);
            var imageAltText = Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_alttext" + itemNumber]);
            var imageAlignment = this.getImageAlignmentClass(parseInt(Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_img_align" + itemNumber]), 10));
            var imageOverlay = this.getImageOverlayClass(parseInt(Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_overlay" + itemNumber]), 10));
            var heading = Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_caption" + itemNumber]);
            var description = Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_desc" + itemNumber]);
            var textAlignment = this.getTextAligmentClass(parseInt(this.cctSettings["custrecord_ns_sc_ext_pg_text_align" + itemNumber], 10));
            var textColor = this.getTextColorClass(parseInt(Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_txtcolor" + itemNumber]), 10));
            var link = Utils_1.Utils.trim(this.cctSettings["custrecord_ns_sc_ext_pg_link" + itemNumber]);
            imageURL = imageURL ? this.getImageResizingURL(imageURL) : '';
            return {
                imageURL: imageURL,
                imageAltText: imageAltText,
                imageAlignment: imageAlignment,
                imageOverlay: imageOverlay,
                heading: heading,
                description: description,
                textAlignment: textAlignment,
                textColor: textColor,
                link: link,
                id: itemNumber,
            };
        };
        PhotoGalleryCCTSettings.prototype.getMaxPhotosQuantity = function () {
            return MAX_PHOTOS;
        };
        PhotoGalleryCCTSettings.prototype.getColumnsPerRow = function () {
            return COLUMNS_PER_ROW;
        };
        PhotoGalleryCCTSettings.prototype.getGalleryHeightClass = function () {
            var galleryHeightId = parseInt(this.cctSettings['custrecord_ns_sc_ext_pg_height'] || '1', 10);
            return GALLERY_HEIGHT[galleryHeightId];
        };
        PhotoGalleryCCTSettings.prototype.getGalleryStyle = function () {
            return Utils_1.Utils.trim(this.cctSettings['custrecord_ns_sc_ext_pg_style']) || '1';
        };
        PhotoGalleryCCTSettings.prototype.getImageHoverAnimationType = function () {
            var imageHoverAnimation = parseInt(Utils_1.Utils.trim(this.cctSettings['custrecord_ns_sc_ext_pg_hover_animation']) || '1', 10);
            return IMAGES_HOVER_ANIMATION[imageHoverAnimation];
        };
        PhotoGalleryCCTSettings.prototype.getCarouselAnimationTime = function () {
            var carouselAnimationTime = parseInt(Utils_1.Utils.trim(this.cctSettings['custrecord_ns_sc_ext_pg_carousel_anim']) || '1', 10);
            return parseInt(CAROUSEL_ANIMATION_TIME[carouselAnimationTime], 10);
        };
        PhotoGalleryCCTSettings.prototype.isCarouselEnabled = function () {
            return parseInt(Utils_1.Utils.trim(this.cctSettings['custrecord_ns_sc_ext_pg_style']), 10) === CAROUSEL_GALLERY_STYLE;
        };
        PhotoGalleryCCTSettings.prototype.openLinksInNewWindow = function () {
            return Utils_1.Utils.trim(this.cctSettings['custrecord_ns_sc_ext_pg_newwindow']) === 'T';
        };
        PhotoGalleryCCTSettings.prototype.getImageAlignmentClass = function (imageAlignmentIndex) {
            return IMAGE_ALIGNMENT[imageAlignmentIndex];
        };
        PhotoGalleryCCTSettings.prototype.getImageOverlayClass = function (imageOverlayIndex) {
            return IMAGE_OVERLAY[imageOverlayIndex];
        };
        PhotoGalleryCCTSettings.prototype.getTextColorClass = function (textColorIndex) {
            return TEXT_COLOR[textColorIndex];
        };
        PhotoGalleryCCTSettings.prototype.getTextAligmentClass = function (textAlignmentIndex) {
            return TEXT_ALIGNMENT[textAlignmentIndex];
        };
        PhotoGalleryCCTSettings.prototype.getImageResizingURL = function (url) {
            var environment = this.container.getComponent('Environment');
            var siteSettings = environment.getSiteSetting();
            var imageSizeDefaultID = 'zoom';
            var imageSizeCustomID = Utils_1.Utils.trim(this.cctSettings['custrecord_sc_ext_pg_image_size_id']);
            var imageSizeCustom = _.find(siteSettings.imagesizes, function (imageResizing) {
                // @ts-ignore
                return imageResizing.name === imageSizeCustomID;
            });
            // @ts-ignore
            var imageSizeID = (imageSizeCustom && imageSizeCustom.name) || imageSizeDefaultID;
            return resizeImage(url, imageSizeID);
        };
        return PhotoGalleryCCTSettings;
    }());
    exports.PhotoGalleryCCTSettings = PhotoGalleryCCTSettings;
});
